'use client';

import { Button } from '@/components/ui';

export const IdentityVerificationDrawer = () => {
  const handleStartVerification = () => {
    // todo: implement verification logic
  };

  return (
    <div className="flex flex-grow flex-col gap-6 px-4 pt-4">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-white mb-3">Realizar saque</h2>
        <p className="text-gray-300 text-sm leading-relaxed">
          Antes de Realizar o saque precisamos verificar sua identidade.
        </p>
      </div>

      <Button
        variant="secondary"
        onClick={handleStartVerification}
        className="h-12 w-full"
        size="large"
      >
        Iniciar Verificação
      </Button>
    </div>
  );
};
